import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class DeclaracionControlService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  realizarPago(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
            realizarPago(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                vendedor_codigo
                chofer_rut
                cliente_proveedor_rut
                otro
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.declaracion_control.realizarPago
        callback({ mensajes, respuesta })
      }
    );
  }

}
